import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './TermsConditionsPage.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const TermsConditionsPage = () => {
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState({
    title: 'Terms & Conditions',
    description: 'Understand the rules, guidelines, and policies that govern the use of our platform.'
  });
  const [paragraphs, setParagraphs] = useState([]);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/settings/content/terms-conditions`);
      if (response.ok) {
        const data = await response.json();
        setPageData({
          title: data.title || 'Terms & Conditions',
          description: data.description || 'Understand the rules, guidelines, and policies that govern the use of our platform.'
        });
        
        let content = [];
        try {
          content = JSON.parse(data.content || '[]');
        } catch (e) {
          content = data.content ? [data.content] : [];
        }
        setParagraphs(content);
      }
    } catch (error) {
      console.error('Error fetching terms conditions content:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="terms-conditions-page">
      <Header />
      
      <main className="terms-main">
        <div className="terms-container">
          {/* Header Section */}
          <div className="terms-header">
            <h1 className="terms-title">{pageData.title}</h1>
            <p className="terms-subtitle">
              {pageData.description}
            </p>
          </div>

          {/* Content Section */}
          <div className="terms-content">
            {loading ? (
              <p className="terms-paragraph">Loading...</p>
            ) : paragraphs.length > 0 ? (
              paragraphs.map((paragraph, index) => (
                <p key={index} className="terms-paragraph">
                  {paragraph}
                </p>
              ))
            ) : (
              <p className="terms-paragraph">
                At Gulf Constructor, we are dedicated to connecting businesses with the right opportunities.
              </p>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsConditionsPage;
